module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/合作.c9049928.png";